import View from 'ln/view/View';
import Course from './views/Course';
import CoursePreview from './views/CoursePreview';
import UserCourseModel from './models/UserCourseModel';
import setup from 'ln/setup/setup';
import { scanner } from 'ln/view/Scanner';
import SequenceScrollMonitor from './slideview/SequenceScrollMonitor';

/**
 * Main class for the course editor
 */
class Editor extends View {
	
	private course:Course|CoursePreview;
	private sequencescrollmonitor:SequenceScrollMonitor;

	init(){
		this.showCourse();
		scanner.scan( this.node );

		this.initSequenceScrollMonitor();

	}

	showCourse() {
		var userCourse = setup.data( 'course' ) as UserCourseModel;
		const courseNode = this.node.js( 'course' );
		if( userCourse.previewMode ){
			this.course = new CoursePreview( userCourse ).render(courseNode) as CoursePreview;
		} else {
			this.course = new Course( userCourse ).render(courseNode) as Course;	
		}
	}
	
	initSequenceScrollMonitor(){
		this.sequencescrollmonitor = scanner.first( 'sequence-scroll-monitor', this.node ) as SequenceScrollMonitor;
		this.sequencescrollmonitor.offsetTop = 75;

		this.updateMonitor();

		// update monitor on added, filled, removed
		this.course.listRenderer.source.added.add( this.updateMonitor, this );
		this.course.listRenderer.source.removed.add( this.updateMonitor, this );
		
	}

	private updateMonitor(){
		this.sequencescrollmonitor.elements = this.course.listRenderer.links.all();
	}

}

export default Editor;

scanner.ioc.add( 'editor', function( node ){
	return new Editor().render( node );
});